import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "https://stormsister.eu/",
});

// Interceptor żądań
API.interceptors.request.use((req) => {
  const token = sessionStorage.getItem("authToken");
  if (token && !req.url.includes("/public")) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  // Ciasteczko będzie automatycznie dołączane do żądania przez przeglądarkę
  return req;
});

// Interceptor odpowiedzi
API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { response, config } = error;

    // Jeśli otrzymaliśmy odpowiedź z kodem 401 (Unauthorized), możemy spróbować odświeżyć token
    if (response?.status === 401 && !config.__isRetryRequest) {
      config.__isRetryRequest = true; // Zapobieganie nieskończonej pętli

      try {
        // Próbujemy odświeżyć token, wysyłając refreshToken (ciasteczko będzie automatycznie wysłane)
        const response = await axios.post("/api/auth/public/refresh", {});

        // Zapisz nowy accessToken w sessionStorage
        const newAccessToken = response.data.accessToken;
        console.log(newAccessToken);
        sessionStorage.setItem("authToken", newAccessToken);

        // Zaktualizuj token w nagłówkach żądania
        config.headers["Authorization"] = `Bearer ${newAccessToken}`;

        // Ponownie wyślij pierwotne żądanie z nowym tokenem
        return axios(config);
      } catch (refreshError) {
        console.log("Error refreshing token", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default API;
